import React, { useContext, useState } from "react";
import TaskActionsDropdown from "./TaskActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Binding from "../../../binding";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import PriorityIcon from "../../Misc/PriorityIcon";

export default function TaskListItem(props) {
  const cx = useContext(Context);
  let data = props || {};
  let binding = new Binding(data.binding || {});
  let validFrom = data.validfromdate ? new Date(data.validfromdate) : {};
  let validTo = data.validtodate ? new Date(data.validtodate) : {};
  const [read, setRead] = useState(data.read);

  let priorityIcon = <PriorityIcon {...data} className={"mr-1"} />;

  let taskContent = null;
  if (binding.url) {
    taskContent = (
      <div>
        <Link
          className="text-dark  text-hover-muted"
          title={`Открыть ${binding.label}`}
          to={binding.url}
          onClick={() => onRead()}
        >
          {priorityIcon}
          {data.label}:
          <div className="mt-1">
            <span className={`mr-2 ${binding.iconClass}`}></span>{" "}
            {binding.label || "Без названия"}
          </div>
        </Link>
      </div>
    );
  } else {
    taskContent = (
      <div>
        {priorityIcon}
        {data.label}
      </div>
    );
  }

  const onRead = () => {
    if (!data.read) {
      if (props.onRead) {
        props.onRead(data);
      }
      setRead(true);
    }
  };

  const onClick = async () => {
    let promptResult = await cx.prompt(
      "",
      "Введите комментарий",
      props.description || ""
    );
    if (promptResult.isConfirmed) {
      props.onChange({
        id: props.id,
        description: promptResult.value || "",
      });
    }
  };

  return (
    <>
      <div>
        <div
          onDoubleClick={() => onRead()}
          className={`row pt-3 pb-3 border-top ${!read && "bg-light"}`}
        >
          <div className="col-lg-3  ">
            <div>
              <i className="fa fa-calendar-plus-o text-muted mr-2"></i>
              {validFrom.toLocaleDateString()}
              <span className="text-dark-50 ml-2">
                {validFrom.toLocaleTimeString()}
              </span>
            </div>
            <div className="mt-1">
              <i className="fa fa-calendar-check-o text-muted mr-2"></i>
              {validTo.toLocaleDateString()}
              <span className="text-dark-50 ml-2">
                {validTo.toLocaleTimeString()}
              </span>
            </div>
          </div>

          <div className="col-lg-4 d-flex align-items-center">
            {taskContent}
          </div>

          <div className="col-lg-3  text-dark-50 small">
            <i className="fa fa-user-o mr-1"></i>
            {data.ownername}
            <div className="mt-2 cursor-pointer" onClick={onClick}>
              <i className="fa fa-pencil mr-1"></i>
              {data.description || (
                <span class="text-muted font-italic">Комментарий к задаче</span>
              )}
            </div>
          </div>

          <div className="col-lg-2 d-flex align-items-center  justify-content-end">
            <EssenceStateLabel
              stateCode={props.statetypecode}
              stateLabel={props.statelabel}
              essence="task"
              id={props.id}
            />

            <TaskActionsDropdown
              className="px-2"
              essence={"task"}
              key={props.id}
              id={props.id}
              label={props.label}
              onFinish={props.onFinish}
            />
          </div>
        </div>
      </div>
    </>
  );
}
